import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col space-x-1"
}
const _hoisted_2 = { class: "flex flex-col w-full text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, "Passagers Concerné", -1)
const _hoisted_4 = { class: "mt-2 text-gray-500" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 border-t border-gray-500" }, null, -1)
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Nom du passagers "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Numéro Téléphone "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_10 = { class: "flex flex-row space-x-1" }
const _hoisted_11 = { class: "flex flex-col w-1/2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Type Pièce "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_13 = { class: "flex flex-col w-1/2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode(" N° pièce d'identification "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, "Ce passager n'est pas sous réservation.", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "flex flex-row items-end justify-end w-full space-x-4" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PassengerReplaceModal',
  props: {
    open: { type: Boolean },
    name: {},
    isLoading: { type: Boolean },
    selectedRow: {},
    passenger: {},
    validations: {},
    identityTypeCards: {}
  },
  emits: ["close", "update:first_name", "update:phone", "update:identity_type_card_id", "update:identity_no", "submit"],
  setup(__props: any) {

	/**
	 * Replace a passenger on a reserved ticket — extracted from NewPassenger.vue.
	 *
	 * Same form layout as PassengerEditModal but gated on the selected row being
	 * a reserved ticket. Reuses the parent's `passengerDataUpdated` buffer so the
	 * same submit handler can process both flows.
	 */
	
	

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalPage, {
        key: 0,
        title: 'Remplacer un passager',
        name: _ctx.name,
        styleContent: "w-full",
        styleFooter: "w-full",
        styleModal: '!w-2/6',
        onClose: _cache[6] || (_cache[6] = (e) => _ctx.$emit('close', e))
      }, {
        content: _withCtx(() => [
          (_ctx.selectedRow.ticket_reserved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedRow.first_name) + " " + _toDisplayString(_ctx.selectedRow.last_name), 1)
                ]),
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_InputTag, {
                    placeholder: "Ex : Paul Martin",
                    type: "text",
                    onModel: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:first_name', e)),
                    value: _ctx.passenger.first_name,
                    error: _ctx.validations.first_name.message
                  }, null, 8, ["value", "error"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_InputTag, {
                    placeholder: "Ex : 699 99 99 99",
                    type: "tel",
                    onModel: _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:phone', e)),
                    value: _ctx.passenger.phone,
                    error: _ctx.validations.phone.message
                  }, null, 8, ["value", "error"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_SelectTag, {
                      placeholder: "Sélectionner un Type Pièce",
                      onModel: _cache[2] || (_cache[2] = (e) => _ctx.$emit('update:identity_type_card_id', e.key)),
                      selected: String(_ctx.passenger.identity_type_card_id ?? 0),
                      error: _ctx.validations.identity_type_card_id.message,
                      data: JSON.stringify(_ctx.identityTypeCards)
                    }, null, 8, ["selected", "error", "data"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_InputTag, {
                      placeholder: "Ex : LT20225565855858585",
                      type: "text",
                      onModel: _cache[3] || (_cache[3] = (e) => _ctx.$emit('update:identity_no', e)),
                      value: _ctx.passenger.identity_no,
                      error: _ctx.validations.identity_no.message
                    }, null, 8, ["value", "error"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_ButtonTag, {
              label: "Annuler",
              activeIcon: false,
              icon: "/media/icons/add-icon.svg",
              css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500 focus:outline-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close', _ctx.name)))
            }),
            (_ctx.selectedRow.ticket_reserved)
              ? (_openBlock(), _createBlock(_component_ButtonTag, {
                  key: 0,
                  label: "Remplacer",
                  activeIcon: false,
                  loader: _ctx.isLoading,
                  "text-loading": 'Transfert en cours...',
                  css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152] focus:outline-none",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit')))
                }, null, 8, ["loader"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["name"]))
    : _createCommentVNode("", true)
}
}

})